import { render, staticRenderFns } from "./Profile2fa.vue?vue&type=template&id=d59e2276&"
import script from "./Profile2fa.vue?vue&type=script&lang=js&"
export * from "./Profile2fa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports